<template>
  <div class="out">
    <div class="page-title">
      <div class="container">
        <b-jumbotron
          :header="header"
          :lead="leader"
          header-tag="h1"
          style="background-color: rgba(0, 0, 0, 0);width:780px"
        />
      </div>
    </div>
    <div class="stickybar">
      <a :style="partI===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(1)">业务挑战</a>
      <a :style="partII===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(2)">解决方案</a>
      <a :style="partIII===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(3)">解决方案优势</a>
      <a :style="partIV===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(4)">成功故事</a>
      <!-- <a :style="partV===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(5)">相关产品</a> -->
    </div>
    <div
      ref="parti"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <div id="partone" class="top-text contenttext">
          <h3>业务挑战</h3>
        </div>
        <introduceCard :arr="cardarr" style="padding-bottom:90px" />
      </div>
    </div>
    <div
      id="parttwo"
      ref="partii"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0;background:url('https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202009/24161717f2kj.png') no-repeat"
    >
      <div class="title">
        <p class="contenttext" style="color:white;text-align:center">
          <br >建筑行业数字化转型解决方案
        </p>
        <div class="introducecard-frame">
          <div v-for="(item,index) in arr2" :key="index" :class="{hoverChange:nowindex2 === index}" class="introducecard2" @mouseenter="mouseOver2(index)" @mouseleave="mouseLeave2(index)">
            <div :style="nowindex2===index ? 'overflow:visible;color:white':'overflow:hidden;color:white'" class="introduceText animation">
              <div class="card-title2"><h4>{{ item.title }}</h4></div>
              <div class="card-text2">{{ item.content }}</div>
              <div v-if="nowindex2===index" class="introduceButton2">
                <router-link class="experience-link" to="/aboutUs">详情咨询</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="partthree"
      ref="partiii"
      class="review"
      style="background-color: rgba(128, 126, 126, 0.074); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <p class="contenttext">
          <br >解决方案优势
        </p>
        <introduceCard3 :arr="cardarr2" style="padding-bottom:90px" />
        <!-- <div class="introducecard-frame">
          <div v-for="(item,index) in arr3" :key="index" class="introducecard2" style="height:364px">
            <div class="image3">
              <img src="https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/1118203743vj.png" alt="">
            </div>
            <div :class="{hoverChange2:nowindex3 === index}" class="introduceText3" @mouseenter="mouseOver3(index)" @mouseleave="mouseLeave3(index)">
              <div class="card-title3"><h4>{{ item.title }}</h4></div>
              <div class="card-text3">{{ item.content }}</div>
              <a v-if= "nowindex3 === index">
                <div class="mybtn" >案例详情</div>
              </a>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div
      id="partfour"
      ref="partiv"
      class="review"
      style="background: rgba(234,239,243,1); margin-left: 0; margin-right: 0;padding-bottom: 60px;"
    >
      <div class="title">
        <card :arr3="arr3" />
      </div>
    </div>
    <!-- <div
      id="partfive"
      ref="partv"
      class="review"
      style="background-color: rgba(128, 126, 126, 0.074); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <p class="contenttext">
          <br >相关产品
        </p>
        <div class="introducecard-frame">
          <div v-for="(item,index) in arr" :key="index" :class="{hoverChange:nowindex === index}" class="introducecard" @mouseenter="mouseOver(index)" @mouseleave="mouseLeave(index)">
            <div v-if="nowindex !== index" class="introduceImage">
              <img :src="item.link" alt="">
            </div>
            <div class="introduceText">
              <div class="card-title"><h4>{{ item.title }}</h4></div>
              <div class="card-text">{{ item.content }}</div>
              <div :style="nowindex===index ? {'opacity':1,'marginTop':'40%'} :'opacity:0'" class="introduceButton">
                <a class="experience-link" href="/access">免费体验</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import introduceCard3 from '@/components/introducecard3'
import introduceCard from '@/components/introducecard2'
import Card from '@/components/introducecard'
export default {
  name: 'Build',
  components: { introduceCard, Card, introduceCard3 },
  data() {
    return {
      header: '建筑行业解决方案',
      leader: '建企业管理标准  筑项目精细运营',
      cardarr: [
        { title: '建立多种采购与供应模式', content: '如何建立多种采购与供应模式，实现集采平台、电商、商城、供应商协同等业务管控，有效降低企业整体的采购成本', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/142155376zu0.png' },
        { title: '强化项目、企业成本精细化管理', content: '如何强化项目、企业的成本精细化管理，打造适合企业的成本管控模式', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/142156391zc0.png' },
        { title: '搭建企业统一的项目管理平台', content: '如何搭建企业统一的项目管理平台，实现合同、进度、资源、成本的有效管理', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14215710l539.png' }
      ],
      cardarr2: [
        { title: '多角色全方位的移动应用体系', content: '提供了全方位、多角色、多业务的移动应用，实现了人与人、人与业务、人与客户的快速连接，实现了业务移动化、沟通移动化、决策移动化，实现管理决策于指尖', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14223547rylq.png' },
        { title: '全面的成本管理优势', content: '提供全程成本管控的模式，实现成本多算管理，支持灵活多样的管控模式，提供多维度的成本分析数据，实现成本与业务模块的无缝集成', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14223624uw9c.png' },
        { title: '深度融合的业财税一体化应用', content: '通过项目管理业务来驱动发票管理、税务管理、财务管理，将合同、结算、发票、资金收付、税务等业务打通，实现了“三证三价三流”的统一', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/142236555h8e.png' },
        { title: '多业务模式的创新管理平台', content: '支持建筑企业产业链一体化、多元化发展战略与商业模式的创新，为企业打造了一个多业务模式、产业链一体化、共享与生态的企业统一信息化管理平台', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14223733yzjv.png' }
      ],
      arr2: [
        { title: '投资类项目管理', content: '为政府、城投市政和机场港口等大型企业进行基建、金融、扩产扩能等项目型投资行为进行标准化、全面管控的解决方案' },
        { title: '建筑项目云', content: '建筑项目云是基于金蝶云•苍穹平台的全新SaaS产品，为行业企业提供施工项目管理、EPC、PPP、装配式建筑等多元化解决方案' },
        { title: '施工项目管理', content: '面向房建、公路、市政、园林、装饰、轨道交通等细分领域的施工企业项目管理一体化解决方案' }
      ],
      arr3: [
        { title: '四川路桥：财务共享助力业务腾飞', content: '实施财务共享管理模式大大提高了业务处理标准化、提高了业务处理效率，为公司实施集团化财务管控提供了很大的帮助，为集团更快速、更高质量发展打好了基础', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/12111329bf5m.png' },
        { title: '隧道股份：业务财务资金一体化，让管理行云流水', content: '金蝶EAS建筑一体化解决方案，帮助上海隧道实现了各类业务活动到财务收付凭证、财务核算的一体化管理，打通了业务数据到财务数据之间的联系', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/12110936diff.png' },
        { title: '歌山建设：江浙企业数字化转型的成功典范', content: '构建一体化、集成化、随需应变的企业管理信息平台，建设综合项目管理系统、财务管理系统、人力资源管理系统、供应链等系统', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/1211085860v7.png' },
        { title: '广西路桥：桥梁施工企业的数字化转型', content: '构建了“WBS+清单+资源”的项目成本精细化管理模式，建立了企业标准工程量清单、标准分包清单、企业定额等企业级管控体系', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/121108046f8n.jpg' }
      ],
      nowindex: '',
      nowindex2: '',
      nowindex3: '',
      nowindex4: 0,
      nowIndex: [0],
      partI: false,
      partII: false,
      partIII: false,
      partIV: false
      // partV: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollLisenter)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollLisenter)
  },
  methods: {
    jump: function(x) {
      if (x === 1) {
        x = '#partone'
      }
      if (x === 2) {
        x = '#parttwo'
      }
      if (x === 3) {
        x = '#partthree'
      }
      if (x === 4) {
        x = '#partfour'
      }
      if (x === 5) {
        x = '#partfive'
      }
      document.querySelector(x).scrollIntoView(true)
    },
    scrollLisenter: function() {
      var length = document.documentElement.scrollTop + 37
      if (length >= 0 && length < this.$refs.partii.offsetTop) {
        this.partI = true
      } else this.partI = false
      if (length > this.$refs.partii.offsetTop && length < this.$refs.partiii.offsetTop) {
        this.partII = true
      } else this.partII = false
      if (length > this.$refs.partiii.offsetTop && length < this.$refs.partiv.offsetTop) {
        this.partIII = true
      } else this.partIII = false
      // if (length > this.$refs.partiv.offsetTop && length < this.$refs.partv.offsetTop) {
      //   this.partIV = true
      // } else this.partIV = false
      if (length > this.$refs.partiv.offsetTop) {
        this.partIV = true
      } else this.partIV = false
    },
    mouseOver: function(x) {
      this.nowindex = x
    },
    mouseLeave: function(x) {
      this.nowindex = -1
    },
    mouseOver2: function(x) {
      this.nowindex2 = x
    },
    mouseLeave2: function(x) {
      this.nowindex2 = -1
    },
    mouseOver3: function(x) {
      this.nowindex3 = x
    },
    mouseLeave3: function(x) {
      this.nowindex3 = -1
    },
    mouseOver4: function(x) {
      this.nowindex4 = x
    },
    mouseLeave4: function(x) {
      this.nowindex4 = x
    },

    mouseOvers: function(type, index) {
      this.nowIndex[type] = index
    },
    mouseLeaves: function(type, index) {
      this.nowIndex[type] = 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.out{
  display: inline-block;
  vertical-align:top;
  width:100%;
}

.page-title {
  background: url('https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/20171621vqfu.png') no-repeat;
  background-size: 100% 100%;
  height: 100%;
  text-align: left;
  padding-top: 60px;
  padding-bottom: 2px;
  /* max-width: 1200px; */
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.title {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
}

.titletext {
  font-size: 50px;
  font-family: "Permanent Marker", cursive;
  color: rgb(22, 21, 21);
}

.contenttext {
  color: rgb(0, 0, 0);
  font-size: 32px;
  /* font-family: Georgia, "Times New Roman", Times, serif; */
  text-align: center;
  padding: 6%;
  padding-top: 4%;
  margin:0;
}

.top-text {
  padding: 50px 0 50px 0;
}

.card {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.introducecard-frame{
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 50px;
}

.introducecard {
  background-color: rgba(236, 234, 227, 0.39);
  width:293px;
  height:315px;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 3px;
  position: relative;
}

.introducecard2 {
  /* background-color: rgba(243, 241, 235, 0.473); */
  /* background-color:rgba(247,247,247,1); */
  background: rgba(35,133,237,0.2);
  height:264px;
  width:584px;
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  margin:0px 8px 20px 8px;
}

.introduceImage {
  padding-top: 50px;
}

.introduceText {
  padding: 20px 30px 30px 30px;
}

.introduceButton {
  border:1px solid rgba(255,255,255,1);
  background-color: rgba(59, 124, 209, 0.39);
  opacity: 0;
  width:100px;
  margin: auto;
  ;
}

.introduceButton2 {
  border:1px solid rgba(255,255,255,1);
  bottom: 75px;
  background-color: rgba(0, 203, 253, 1);
  width:100px;
  margin: auto;
}

.introduceButton a {
    color:rgba(251,252,253,1);
    font-size:14px;
    text-align: center;
    line-height: 40px;
    text-decoration: none;
}

.introduceButton2 a {
    color:rgba(251,252,253,1);
    font-size:14px;
    text-align: center;
    line-height: 40px;
    text-decoration: none;
}

.hoverChange {
  background-color: rgba(20, 130, 238, 1);
  transition: 0.4s;
  color:white;
  box-shadow: 0px 0px 5px #000;
}

.animation {
  position: relative;
  transition: all 0.4s;
}

.animation:hover {
  transition: transform 0.4s;
  transform: translateY(-40px);
}

.card-title2 {
  margin-top: 10%;
  text-align: left;
}

.card-title3 {
  margin-top: 1%;
  text-align: left;
}

.card-text2 {
  word-break:hyphenate;
  font-size: 14px;
  padding-top: 2%;
  padding-bottom: 2%;
  text-align: left;
  height:120px;
}

.card-text3 {
  font-size: 14px;
  text-align: left;
}

.introduceText3 {
  background-color: rgb(255, 255, 255);
  position: absolute;
  bottom:0;
  transition: all 0.4s;
  height: 140px;
  padding:4%;
}

.introduceText3:hover {
  height: 200px;
  transition:0.4s;
}

.introducecard2 img {
  width:100%;
}

.mybtn {
  width:25%;
  background-color: rgb(62, 88, 112);
  margin: 30px auto;
  padding: 1%;
  color: white;
}

.leftMenu {
  display: flex;
  flex-direction: column;
  width: 150px;
  text-align: left;
  padding: 10% 0%;
  box-shadow: -20px 0px 20px -10px rgb(0 0 0 / 4%) inset;
}

.leftMenu-item {
  padding:18% 10% 18% 10%;
  position: relative;
}

.rightContent {
  width: 100%;
  background-color: rgba(128, 126, 126, 0.075);
  padding:10%;
}

.hoverItem {
  background-color: rgba(45,139,238,1);
  color: ivory;
  width:140%;
  font-size: 20px;
}

.big-title {
  margin: auto;
  padding:5%;
}

.stickybar {
  position: sticky;
  top: 0;
  display: flex;
  background-color: white;
  z-index: 99;
  padding: 0% 7% 0% 13%;
}

.stickybar a{
  padding: 2% 4%;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/views/solutions/components/build.vue